//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { AdvisoryFilterDTO } from 'src/app/core/models/system/riskline/riskline-advisory.dto';
import { AlertFilterDTO } from 'src/app/core/models/system/riskline/riskline-alert.dto';
import { createAction, props } from '@ngrx/store';
import { LocalRiskLevelRequestDTO, LocalRiskLevelResponseDTO } from 'src/app/core/models/system/riskline/riskline-local-risk-level.dto';
import { RisklineAdvisoryModel, RisklineAlertModel, RisklineCityReportModel, RisklineCountryReportModel, RisklineCountryRiskLevelModel, RisklinePtaModel, RisklineStaModel, RisklineSummaryModel, RisklineTravelSearchModel, RisklineTripReadyModel } from './risk_intelligence_model';
import { TravelSearchRequestDTO } from 'src/app/core/models/system/riskline/riskline-travel-search.dto';
import { TripReadyRequestDTO } from 'src/app/core/models/system/riskline/riskline-trip-ready.dto';

//#region Alerts (PUSH - SignalR-driven)

export const fetchAlerts       =createAction('[RiskIntelligence] Fetch Alerts'        , props<{ filter: AlertFilterDTO      ; }>());
export const fetchAlertsSuccess=createAction('[RiskIntelligence] Fetch Alerts Success', props<{ alerts: RisklineAlertModel[]; }>());
export const fetchAlertsFailure=createAction('[RiskIntelligence] Fetch Alerts Failure', props<{ error : string              ; }>());

export const alertReceivedFromHub=createAction('[RiskIntelligence] Alert Received From Hub', props<{ alert: RisklineAlertModel; }>());
export const alertUpdatedFromHub =createAction('[RiskIntelligence] Alert Updated From Hub' , props<{ alert: RisklineAlertModel; }>());
export const alertDeletedFromHub =createAction('[RiskIntelligence] Alert Deleted From Hub' , props<{ id   : string            ; }>());

//#endregion

//#region Advisories (PUSH)

export const fetchAdvisories       =createAction('[RiskIntelligence] Fetch Advisories'        , props<{ filter?   : AdvisoryFilterDTO      ; }>());
export const fetchAdvisoriesSuccess=createAction('[RiskIntelligence] Fetch Advisories Success', props<{ advisories: RisklineAdvisoryModel[]; }>());
export const fetchAdvisoriesFailure=createAction('[RiskIntelligence] Fetch Advisories Failure', props<{ error     : string                 ; }>());

export const fetchAdvisoryById       =createAction('[RiskIntelligence] Fetch Advisory By Id'        , props<{ id      : string;                }>());
export const fetchAdvisoryByIdSuccess=createAction('[RiskIntelligence] Fetch Advisory By Id Success', props<{ advisory: RisklineAdvisoryModel; }>());
export const fetchAdvisoryByIdFailure=createAction('[RiskIntelligence] Fetch Advisory By Id Failure', props<{ error   : string;                }>());

export const advisoryReceivedFromHub=createAction('[RiskIntelligence] Advisory Received From Hub', props<{ advisory: RisklineAdvisoryModel; }>());
export const advisoryUpdatedFromHub =createAction('[RiskIntelligence] Advisory Updated From Hub' , props<{ advisory: RisklineAdvisoryModel; }>());
export const advisoryDeletedFromHub =createAction('[RiskIntelligence] Advisory Deleted From Hub' , props<{ id      : string               ; }>());

//#endregion

//#region Country Risk Levels (PULL + PUSH)

export const fetchCountryRiskLevels       =createAction('[RiskIntelligence] Fetch Country Risk Levels'                                                                   );
export const fetchCountryRiskLevelsSuccess=createAction('[RiskIntelligence] Fetch Country Risk Levels Success', props<{ riskLevels: RisklineCountryRiskLevelModel[]; }>());
export const fetchCountryRiskLevelsFailure=createAction('[RiskIntelligence] Fetch Country Risk Levels Failure', props<{ error     : string                         ; }>());

export const countryRiskLevelReceivedFromHub=createAction('[RiskIntelligence] Country Risk Level Received From Hub', props<{ riskLevel     : RisklineCountryRiskLevelModel; }>());
export const countryRiskLevelDeletedFromHub =createAction('[RiskIntelligence] Country Risk Level Deleted From Hub' , props<{ countryIsoCode: string; language: string     ; }>());

//#endregion

//#region Summaries (PULL + PUSH)

export const fetchSummaryForCountry       =createAction('[RiskIntelligence] Fetch Summary For Country'        , props<{ isoCode: string              ; }>());
export const fetchSummaryForCountrySuccess=createAction('[RiskIntelligence] Fetch Summary For Country Success', props<{ summary: RisklineSummaryModel; }>());
export const fetchSummaryForCountryFailure=createAction('[RiskIntelligence] Fetch Summary For Country Failure', props<{ error  : string              ; }>());

export const summaryReceivedFromHub=createAction('[RiskIntelligence] Summary Received From Hub', props<{ summary       : RisklineSummaryModel    ; }>());
export const summaryDeletedFromHub =createAction('[RiskIntelligence] Summary Deleted From Hub' , props<{ countryIsoCode: string; language: string; }>());

//#endregion

//#region PTAs (PUSH)

export const fetchPtaForCountry       =createAction('[RiskIntelligence] Fetch PTA For Country'        , props<{ isoCode: string          ; }>());
export const fetchPtaForCountrySuccess=createAction('[RiskIntelligence] Fetch PTA For Country Success', props<{ pta    : RisklinePtaModel; }>());
export const fetchPtaForCountryFailure=createAction('[RiskIntelligence] Fetch PTA For Country Failure', props<{ error  : string          ; }>());

export const ptaReceivedFromHub=createAction('[RiskIntelligence] PTA Received From Hub', props<{ pta           : RisklinePtaModel        ; }>());
export const ptaDeletedFromHub =createAction('[RiskIntelligence] PTA Deleted From Hub' , props<{ countryIsoCode: string; language: string; }>());

//#endregion

//#region Country Reports (PUSH)

export const fetchCountryReport       =createAction('[RiskIntelligence] Fetch Country Report'        , props<{ isoCode: string                    ; }>());
export const fetchCountryReportSuccess=createAction('[RiskIntelligence] Fetch Country Report Success', props<{ report : RisklineCountryReportModel; }>());
export const fetchCountryReportFailure=createAction('[RiskIntelligence] Fetch Country Report Failure', props<{ error  : string                    ; }>());

export const countryReportReceivedFromHub=createAction('[RiskIntelligence] Country Report Received From Hub', props<{ report        : RisklineCountryReportModel; }>());
export const countryReportDeletedFromHub =createAction('[RiskIntelligence] Country Report Deleted From Hub' , props<{ countryIsoCode: string; language: string  ; }>());

//#endregion

//#region City Reports (PUSH)

export const fetchCityReport       =createAction('[RiskIntelligence] Fetch City Report'        , props<{ iataCode: string                 ; }>());
export const fetchCityReportSuccess=createAction('[RiskIntelligence] Fetch City Report Success', props<{ report  : RisklineCityReportModel; }>());
export const fetchCityReportFailure=createAction('[RiskIntelligence] Fetch City Report Failure', props<{ error   : string                 ; }>());

export const fetchAllCityReports       =createAction('[RiskIntelligence] Fetch All City Reports'                                                          );
export const fetchAllCityReportsSuccess=createAction('[RiskIntelligence] Fetch All City Reports Success', props<{ reports: RisklineCityReportModel[]; }>());
export const fetchAllCityReportsFailure=createAction('[RiskIntelligence] Fetch All City Reports Failure', props<{ error  : string; }>()                   );

export const cityReportReceivedFromHub=createAction('[RiskIntelligence] City Report Received From Hub', props<{ report  : RisklineCityReportModel; }>());
export const cityReportDeletedFromHub =createAction('[RiskIntelligence] City Report Deleted From Hub' , props<{ iataCode: string                 ; }>());

//#endregion

//#region Specific Traveller Advice (PUSH)

export const fetchStaForCountry       =createAction('[RiskIntelligence] Fetch STA For Country'        , props<{ isoCode: string          ; }>());
export const fetchStaForCountrySuccess=createAction('[RiskIntelligence] Fetch STA For Country Success', props<{ sta    : RisklineStaModel; }>());
export const fetchStaForCountryFailure=createAction('[RiskIntelligence] Fetch STA For Country Failure', props<{ error  : string          ; }>());

export const staReceivedFromHub=createAction('[RiskIntelligence] STA Received From Hub', props<{ sta    : RisklineStaModel; }>());
export const staDeletedFromHub =createAction('[RiskIntelligence] STA Deleted From Hub' , props<{ isoCode: string          ; }>());

//#endregion

//#region Travel Search (PULL)

export const executeTravelSearch       =createAction('[RiskIntelligence] Execute Travel Search'        , props<{ request: TravelSearchRequestDTO   ; }>());
export const executeTravelSearchSuccess=createAction('[RiskIntelligence] Execute Travel Search Success', props<{ result : RisklineTravelSearchModel; }>());
export const executeTravelSearchFailure=createAction('[RiskIntelligence] Execute Travel Search Failure', props<{ error  : string                   ; }>());

export const clearTravelSearchResult=createAction('[RiskIntelligence] Clear Travel Search Result');

//#endregion

//#region TripReady (PULL)

export const executeTripReady       =createAction('[RiskIntelligence] Execute TripReady'        , props<{ request: TripReadyRequestDTO   ; }>());
export const executeTripReadySuccess=createAction('[RiskIntelligence] Execute TripReady Success', props<{ result : RisklineTripReadyModel; }>());
export const executeTripReadyFailure=createAction('[RiskIntelligence] Execute TripReady Failure', props<{ error  : string                ; }>());

export const clearTripReadyResult=createAction('[RiskIntelligence] Clear TripReady Result');

//#endregion

//#region Local Risk Levels (PULL)

export const executeLocalRiskLevels       =createAction('[RiskIntelligence] Execute Local Risk Levels'        , props<{ request: LocalRiskLevelRequestDTO ; }>());
export const executeLocalRiskLevelsSuccess=createAction('[RiskIntelligence] Execute Local Risk Levels Success', props<{ result : LocalRiskLevelResponseDTO; }>());
export const executeLocalRiskLevelsFailure=createAction('[RiskIntelligence] Execute Local Risk Levels Failure', props<{ error  : string                   ; }>());

export const clearLocalRiskLevelsResult=createAction('[RiskIntelligence] Clear Local Risk Levels Result');

//#endregion
